// api
import { fetchApi } from '@/api'
// actions
const restaurantEnlistmentAll = (context) => {
  let url = 'restaurant/enlistment'
  let data = {}
  fetchApi(url, data, 'GET')
    .then((response) => {
      console.log(response)
      context.commit('RESTAURANT_ENLISTMENT_ALL', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const restaurantEnlistmentForm = (context) => {
  let url = 'restaurant/enlistment/create'
  let data = {}
  fetchApi(url, data, 'GET')
    .then((response) => {
      console.log(response)
      context.commit('RESTAURANT_ENLISTMENT_FORM', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const restaurantEnlistmentShow = (context) => {
  let url = 'restaurant/enlistment'
  let data = {}
  fetchApi(url, data, 'POST')
    .then((response) => {
      console.log(response)
      context.commit('RESTAURANT_ENLISTMENT_SHOW', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

// actions
const restaurantEnlistmentCreate = (context) => {
  let url = 'restaurant/enlistment/create'
  let data = {}
  fetchApi(url, data, 'POST')
    .then((response) => {
      console.log(response)
      context.commit('RESTAURANT_ENLISTMENT_CREATE', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const restaurantEnlistmentUpdate = (context) => {
  let url = 'restaurant/enlistment'
  let data = {}
  fetchApi(url, data, 'PUT')
    .then((response) => {
      context.commit('RESTAURANT_ENLISTMENT_UPDATE', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

const restaurantEnlistmentDelete = (context, payload) => {
  let url = 'restaurant/enlistment'
  console.log(payload)
  fetchApi(url, payload, 'DELETE')
    .then((response) => {
      context.commit('RESTAURANT_ENLISTMENT_DELETE', response)
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error)
    })
}

export default {
  restaurantEnlistmentAll,
  restaurantEnlistmentForm,
  restaurantEnlistmentShow,
  restaurantEnlistmentCreate,
  restaurantEnlistmentUpdate,
  restaurantEnlistmentDelete
}



// WEBPACK FOOTER //
// ./src/store/modules/restaurant/enlistment/actions.js